import {
  Auth0Client,
  ResponseType,
  type RedirectLoginResult,
  type GetTokenSilentlyOptions,
  type GetTokenSilentlyVerboseResponse,
} from '@auth0/auth0-spa-js';
import type { ConnectAccountRedirectResult, User } from '@auth0/auth0-react';
import {
  AUTH0_ORGANIZATION_KEY,
  AUTH0_ROLES_KEY,
  AUTH0_ADMIN_ROLE_NAME,
} from './config';

const dummyUser: User = {
  sub: 'dummy',
  name: 'Dummy User',
  [AUTH0_ORGANIZATION_KEY]: {
    name: 'org_dummy',
    display_name: 'Dummy Organization',
  },
  [AUTH0_ROLES_KEY]: [AUTH0_ADMIN_ROLE_NAME],
};

class DummyAuth0Client extends Auth0Client {
  async checkSession(): Promise<void> {}

  async getUser<TUser extends User>(): Promise<TUser> {
    return dummyUser as TUser;
  }

  async getTokenSilently(
    options: GetTokenSilentlyOptions & {
      detailedResponse: true;
    }
  ): Promise<GetTokenSilentlyVerboseResponse>;
  async getTokenSilently(options?: GetTokenSilentlyOptions): Promise<string>;
  async getTokenSilently(
    options?: GetTokenSilentlyOptions
  ): Promise<string | GetTokenSilentlyVerboseResponse> {
    if (options?.detailedResponse) {
      return {
        token_type: 'Bearer',
        id_token: 'dummy',
        access_token: 'dummy',
        expires_in: 60 * 60 * 24,
      };
    }
    return 'dummy';
  }

  async handleRedirectCallback<T>(): Promise<
    RedirectLoginResult<T> | ConnectAccountRedirectResult<T>
  > {
    return { appState: {} as T, response_type: ResponseType.Code };
  }

  async loginWithRedirect(): Promise<void> {}

  async logout(): Promise<void> {}

  async isAuthenticated(): Promise<boolean> {
    return true;
  }
}

const dummyClient = new DummyAuth0Client({
  domain: 'dummy',
  clientId: 'dummy',
});

export { dummyClient };
